module.exports = __webpack_public_path__ + "img/tailwindcss.ae552627.svg";